var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticket-component" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: { paths: [{ title: _vm.$t("message.ticket") }], select: true },
        },
        [
          _c(
            "div",
            { staticClass: "chatListSettingContainer" },
            [
              _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb new-status-button",
                  staticStyle: { "margin-right": "8px" },
                  on: { click: _vm.showModal },
                },
                [
                  _c("md-icon", [_vm._v("add")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.addNewStatus")) +
                      "\n            "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb list-status-button",
                  staticStyle: { "margin-right": "8px" },
                  on: { click: _vm.statusShowModal },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.listStatuses")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("SidebarChild", {
            attrs: {
              items: _vm.menuItems,
              focusActive: true,
              selectedItem: _vm.selectedTab,
              className: "ticket-menu",
            },
            on: { selected: _vm.handleSidebarSelection },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "position-relative pt-3",
              staticStyle: { padding: "0 30px" },
            },
            [
              _c(
                "a-row",
                [
                  _c("a-col", { attrs: { span: "24" } }, [
                    _vm.selectedTab === "tickets"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: {
                                "default-filter-template":
                                  _vm.currentFilterTemplate,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "chatbot"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "chatbot" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "offline"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "offline" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "instagram"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "instagram" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "facebook"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "messenger" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "trendyol"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "trendyol" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "form"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: { "default-filter-template": "form" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "automation"
                      ? _c(
                          "div",
                          [
                            _c("TicketList", {
                              attrs: {
                                "default-filter-template": "automation",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "ticket-automations"
                      ? _c(
                          "div",
                          [
                            _c("AutomationList", {
                              attrs: { type: "event", module: "ticket" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "messenger"
                      ? _c(
                          "div",
                          [
                            _c("AwaitingTickets", {
                              attrs: {
                                "show-my-tickets": _vm.showMyTicket,
                                tag: _vm.selectedTopic,
                                statuses: _vm.statuses,
                                platform: "messenger",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTab === "settings"
                      ? _c("div", [_c("TicketSettings")], 1)
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              staticClass: "ticket-status-form large",
              attrs: {
                id: "ticket-status-form",
                "show-footer": false,
                title: _vm.ticketFormMode
                  ? _vm.$t("message.ticketStatusForm")
                  : _vm.$t("message.listStatuses"),
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _vm.ticketFormMode
                ? _c(
                    "div",
                    [
                      _c(
                        "b-form",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSave.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "message.statusFormTitle"
                                                ),
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  name: _vm.$t(
                                                    "message.statusFormTitle"
                                                  ),
                                                  autocomplete: "off",
                                                  trim: "",
                                                  type: "text",
                                                },
                                                model: {
                                                  value: _vm.statusForm.title,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.statusForm,
                                                      "title",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "statusForm.title",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12", id: "buttons" } },
                                        [
                                          _c(
                                            "b-button",
                                            { on: { click: _vm.hideModal } },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                type: "submit",
                                                variant: "primary",
                                              },
                                              on: {
                                                submit: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleSave.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              !_vm.statusForm._id
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t("message.save")
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.update"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("StatusTable", {
                        attrs: { statuses: _vm.statuses },
                        on: { edit: _vm.editStatus, deleted: _vm.deleted },
                      }),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }